import { render, staticRenderFns } from "./ExtraLeavePolicyView.vue?vue&type=template&id=2d9d73b4&"
import script from "./ExtraLeavePolicyView.vue?vue&type=script&lang=js&"
export * from "./ExtraLeavePolicyView.vue?vue&type=script&lang=js&"
import style0 from "./ExtraLeavePolicyView.vue?vue&type=style&index=0&id=2d9d73b4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports